var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('a',{staticClass:"footer__link",attrs:{"href":"https://dianet.online/contracts?id=6#lkRules","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('footer.terms')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }